// React i hooks

// Tipovi i konstante
import { FleetSettingDetailPageCmp, FleetSettingDetailPageProps } from "./types";
import { SETTING_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import { SIDEBAR_ITEM_SETTING } from "app/components/Sidebar/consts";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// Moduli specifični za projekt
import { Routes } from "ui/modules/settings/navigation";
import TabMenu from "ui/modules/settings/pages/tenant/components/TabMenu/TabMenu";
import { getActiveUser } from "services/api/users";
import { useSelector } from "react-redux";
import FleetSettingDetailCard from "./components/FleetSettingDetailCard/FleetSettingDetailCard";


const FleetSettingDetailPage: FleetSettingDetailPageCmp = (
  props: FleetSettingDetailPageProps
) => {
  const { user } = useSelector(getActiveUser);

  const title = SETTING_DETAIL_PAGE_TITLE;

  const breadcrumbs: BreadcrumbItem[] = [
    { text: SIDEBAR_ITEM_SETTING.text, route: SIDEBAR_ITEM_SETTING.route },
  ];

  if (!user) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title={`${title.text}`}
              icon={title.icon}
              iconColor={title.iconColor}
            />
            <Breadcrumb items={breadcrumbs} />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <FleetSettingDetailCard />
        </div>
      </div>
    </>
  );
};

FleetSettingDetailPage.route = Routes.FleetSettingDetailPageRouter;

export default FleetSettingDetailPage;
